import {schema} from 'normalizr';

export default new schema.Entity('pipings', {

});